import styled from "@emotion/styled";

import { styleCss } from "components/layout/utils";

interface ILinkStyledButtonProps {
  color?: string;
  display?: string;
  fontWeight?: string;
  fontSize?: string;
  noUnderline?: boolean;
  lineHeight?: string;
  textDecoration?: "underline";
}

const LinkStyledButton = styled.button<ILinkStyledButtonProps>`
  appearance: none;
  color: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    ({ theme, color = "linkColor" }: any) => theme[color]
  };
  outline: none;
  margin: 0;
  padding: 0;
  border: none;
  cursor: pointer;
  background-color: transparent;
  font-size: 14px;
  ${styleCss("lineHeight")}
  ${styleCss("display")}
  ${styleCss("fontWeight")}
  ${styleCss("textDecoration")}

  &:hover {
    ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => (props.noUnderline ? "" : "text-decoration: underline;")
    }
  }

  &:disabled {
    opacity: 0.6;
    text-decoration: none;
  }
`;

export default LinkStyledButton;
